import { render, staticRenderFns } from "./network_error.vue?vue&type=template&id=70155e4b&scoped=true&"
import script from "./network_error.vue?vue&type=script&lang=js&"
export * from "./network_error.vue?vue&type=script&lang=js&"
import style0 from "./network_error.vue?vue&type=style&index=0&id=70155e4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70155e4b",
  null
  
)

export default component.exports